/*! MakNorte — preserve native responsive images and explicit loading priorities. */
(function(){
  function enforceLazy(){
    const fold=window.innerHeight+200;
    document.querySelectorAll('img').forEach(img=>{
      if(img.hasAttribute('loading') || img.fetchPriority==='high')return;
      const r=img.getBoundingClientRect();
      if(r.top>fold)img.loading='lazy';
    });
  }
  // Keep Liquid's srcset/sizes: the browser selects by slot width and pixel density.
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enforceLazy);else enforceLazy();
})();
